// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TabsMenu-content{margin-bottom:15px}", "",{"version":3,"sources":["webpack://./components/TabsMenu/index.sass"],"names":[],"mappings":"AAAA,kBACE,kBAAA","sourcesContent":[".TabsMenu-content\n  margin-bottom: 15px\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
